import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FilterElementComponent } from '../filter-inputs/filter-element/filter-element.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-filter-content-block',
    templateUrl: './filter-content-block.component.html',
    styleUrls: [
        './filter-content-block.component.scss',
        '../filter-inputs/filter-element/filter-element.component.scss',
    ],
    imports: [],
})
export class FilterContentBlockComponent extends FilterElementComponent {
    @Input()
    public title = '';
}
